var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.887 26L10.1318 25.3527C9.09068 24.4809 0 16.6299 0 10.887C0 4.87429 4.87429 0 10.887 0C16.8997 0 21.774 4.87429 21.774 10.887C21.774 16.6299 12.6833 24.4809 11.6465 25.357L10.887 26ZM10.887 2.35409C6.17665 2.35942 2.35947 6.1766 2.35414 10.887C2.35414 14.4947 7.94708 20.2581 10.887 22.896C13.827 20.257 19.4199 14.4904 19.4199 10.887C19.4145 6.1766 15.5974 2.35947 10.887 2.35409Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8868 15.2026C8.50341 15.2026 6.57129 13.2704 6.57129 10.887C6.57129 8.50366 8.50341 6.57153 10.8868 6.57153C13.2702 6.57153 15.2023 8.50366 15.2023 10.887C15.2023 13.2704 13.2702 15.2026 10.8868 15.2026ZM10.8868 8.72924C9.69511 8.72924 8.72905 9.6953 8.72905 10.887C8.72905 12.0787 9.69511 13.0448 10.8868 13.0448C12.0785 13.0448 13.0446 12.0787 13.0446 10.887C13.0446 9.6953 12.0786 8.72924 10.8868 8.72924Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMarker);
export default __webpack_public_path__ + "static/media/black-marker.b2d36c2f1481d8796710900b21103873.svg";
export { ForwardRef as ReactComponent };